@if (item) {
  <div class="stitch-list-item with-bar board-row" [class.board-row-pinned]="item.pinned" [class.selected]="selected && !isDragging" [class.hovered]="contextMenuOpened"
    [appFormContextMenu]="item" (appFormContextMenuOpen)="open.emit()"
    appDraggable [appDraggableData]="dragData" [appDraggableDisabled]="!dragEnabled" [appDraggablePlaceholder]="dragPlaceholder"
    (appDraggableDraggingChanged)="isDragging = $event"
    appDroppable [appDroppableDisabled]="!dragEnabled || item.deleted" appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate" (appDroppableDrop)="dndDrop($event)"
    (appClick)="onClick.emit(item)" (appDblClick)="onDoubleClick.emit(item)">
    <span class="board-row-thumbnail form-row-thumbnail" aria-hidden="true"><app-icon name="sapphire-form" [size]="22" /></span>
    <div class="stitch-list-item-body">
      <div class="stitch-list-item-body-header">
        <div class="stitch-list-item-body-title"><div class="stitch-list-item-body-title-text" [class.blank]="!item.title">{{ item.title || 'Untitled form' }}</div></div>
        <div class="stitch-list-item-hover-actions" [appClickStopPropagation]="true">
          <stch-quick-action icon="sapphire-archive2" [active]="item.archived" (onClick)="archive()" [matTooltip]="item.archived ? Labels.RestoreFromArchive : Labels.Archive" />
          <stch-trash-action [deleted]="item.deleted" (onClick)="delete()" />
        </div>
      </div>
      <div class="stitch-list-item-body-item inline">Created: {{ item.createdAt | dateFormat: 'relativeDate' }}
        <div class="stitch-list-item-body-item-separator"></div>Updated: {{ item.updatedAt | dateFormat: 'relativeDate' }}</div>
      <div class="stitch-list-item-body-item truncate">{{ item.responseCount }} {{ item.responseCount === 1 ? 'response' : 'responses' }} | {{ item.accepting ? 'Collecting' : item.publishedVersion ? 'Closed' : 'Draft' }}</div>
      <div class="bottom-bar">
        <div
          [appStitchInfoPopover]="item"
          [appStitchInfoPopoverContent]="linkedInfoPopoverContent"
          stchPopoverPlacement="bottom"
          (appStitchInfoPopoverOpened)="stitchExpanded = $event; barExpanded = $event"
          (appStitchInfoPopoverItemClick)="openStitchItem($event)"
          (appStitchInfoPopoverItemDoubleClick)="openStitchItem($event)"
          [appClickStopPropagation]="true"
          class="bottom-bar-item shrink-0"
          [class.expanded]="stitchExpanded"
        >
          <app-icon class="bottom-bar-item-icon" name="sapphire-stitch" />
          <span>{{ (stitchCount$ | async) ?? 0 }}</span>
          <app-icon class="bottom-bar-item-icon chevron" name="sapphire-chevron-down" />
        </div>

        @if (locationBadge(); as badge) {
          <app-search-location-badge class="min-w-0 shrink" type="form-folder" [name]="badge.name" />
        }

        <div class="flex-1"></div>

        @if (item.snoozed) {
          <app-icon
            class="bottom-bar-item-icon shrink-0 snoozed"
            name="sapphire-snooze"
            [matTooltip]="'Snoozed until ' + (item.snoozed | dateFormat: 'dateTime')"
          />
        }
        @if (item.followed) {
          <app-icon
            class="bottom-bar-item-icon shrink-0 followed"
            name="sapphire-follow-up"
            [matTooltip]="'Follow up on ' + (item.followed | dateFormat: 'dateTime')"
          />
        }
        <app-button2
          class="bottom-bar-action shrink-0"
          [class.active]="item.flagged"
          appearance="secondary-ghost"
          size="s"
          [appClickStopPropagation]="true"
          (click)="flag($event)"
        >
          <app-flagged-icon [active]="item.flagged" />
        </app-button2>
        <app-button2
          class="bottom-bar-action shrink-0"
          [class.active]="item.pinned"
          appearance="secondary-ghost"
          size="s"
          [appClickStopPropagation]="true"
          (click)="pin($event)"
        >
          <stch-pinned-icon [active]="item.pinned" />
        </app-button2>
      </div>
    </div>
    <div class="drop-zone"></div>
  </div>
}

<ng-template #linkedInfoPopoverContent let-stitch let-clickStitchItem="clickStitchItem" let-dblClickStitchItem="dblClickStitchItem">
  <app-linked-info-list
    class="container"
    [stitch]="stitch"
    [state]="popoverListState"
    [unlinkParentPairsOnly]="true"
    (clickStitchItem)="clickStitchItem.emit($event)"
    (dblClickStitchItem)="dblClickStitchItem.emit($event)"
  />
</ng-template>

<ng-template #dragPlaceholder>
  <app-forms-library-card [item]="item" [dragEnabled]="false" />
</ng-template>
